import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
  ListItem,
  ListItemText,
  Chip,
  Box,
  TextField,
  Paper,
  TableContainer,
  TableHead,
  TableBody,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import { useAwaitDialog } from "app/components/status_dialog";
import * as XLSX from "xlsx";
import AppConfig from "appConfig";
import { List } from "react-movable";

function CallCenterPage() {
  const pageTitle = "Voice - Call Center";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const statusDialog = useAwaitDialog();
  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [currency, setCurrency] = useState(null);
  const [callCenter, setCallCenter] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState([]);
  const [callCenterNumbers, setCallCenterNumbers] = useState([]);
  const [agentGroups, setAgentGroups] = useState([]);
  const [callCenterAgentGroups, setCallCenterAgentGroups] = useState([]);
  const [contacts, setContacts] = useState(0);
  const [tags, setTags] = useState([]);
  const [callOutcomes, setCallOutcomes] = useState([]);
  const [resultData, setResultData] = useState({});

  const [callCenterCampaigns, setCallCenterCampaigns] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [openAttachCampaignDialog, setOpenAttachCampaignDialog] = useState(false);

  const [callCenterWaccs, setCallCenterWaccs] = useState([]);
  const [waccNumbers, setWaccNumbers] = useState([]);
  const [selectedWacc, setSelectedWacc] = useState(null);
  const [waccTitle, setWaccTitle] = useState(null);
  const [openAttachWaccDialog, setOpenAttachWaccDialog] = useState(false);

  const [tableRows, setTableRows] = useState([]);
  const [selectedAgentGroup, setSelectedAgentGroup] = useState(null);
  const [canCall, setCanCall] = useState(true);
  const [canReceive, setCanReceive] = useState(true);
  const [selectedTags, setSelectedTags] = useState([]);
  const [openNewAgentGroupDialog, setOpenNewAgentGroupDialog] = useState(false);

  const [selectedNumber, setSelectedNumber] = useState(null);
  const [openAttachNumberDialog, setOpenAttachNumberDialog] = useState(false);

  const [entityTitle, setEntityTitle] = useState(null);
  const [openOutcomeDialog, setOpenOutcomeDialog] = useState(false);
  const [openTagDialog, setOpenTagDialog] = useState(false);

  const [uploadFile, setUploadFile] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);
  const [openUploadContactsDialog, setOpenUploadContactsDialog] = useState(false);

  const [subscription, setSubscription] = useState(null);
  const [tiers, setTiers] = useState([]);
  const [selectedTier, setSelectedTier] = useState(null);
  const [selectedTierObject, setSelectedTierObject] = useState({});
  const [subscriptionDuration, setSubscriptionDuration] = useState(1);
  const [openSubscriptionDialog, setOpenSubscriptionDialog] = useState(false);
  const [addons, setAddons] = useState([]);
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [openAddonDialog, setOpenAddonDialog] = useState(false);

  const [voicemailText, setVoicemailText] = useState(null);
  const [voicemailAudio, setVoicemailAudio] = useState(null);
  const [voicemailMsg, setVoicemailMsg] = useState(null);
  const [voicemailFile, setVoicemailFile] = useState(null);
  const [openVoicemailDialog, setOpenVoicemailDialog] = useState(false);

  const [welcomeMessageText, setWelcomeMessageText] = useState(null);
  const [welcomeMessageAudio, setWelcomeMessageAudio] = useState(null);
  const [welcomeMessageMsg, setWelcomeMessageMsg] = useState(null);
  const [welcomeMessageFile, setWelcomeMessageFile] = useState(null);
  const [openWelcomeMessageDialog, setOpenWelcomeMessageDialog] = useState(false);

  const [operatingHours, setOperatingHours] = useState([]);
  const [operatingDay, setOperatingDay] = useState([]);
  const [operatingDirection, setOperatingDirection] = useState([]);
  const [operatingStart, setOperatingStart] = useState(null);
  const [operatingEnd, setOperatingEnd] = useState(null);
  const [operatingEnabled, setOperatingEnabled] = useState(null);
  const [operatingGroup, setOperatingGroup] = useState([]);
  const [openOperatingHoursDialog, setOpenOperatingHoursDialog] = useState(false);

  const [ivr, setIvr] = useState(null);
  const [ivrAudio, setIvrAudio] = useState(null);
  const [ivrMsg, setIvrMsg] = useState(null);
  const [ivrText, setIvrText] = useState(null);
  const [ivrFile, setIvrFile] = useState(null);
  const [ivrDMFT, setIvrDMFT] = useState(null);
  const [openIvrDialog, setOpenIvrDialog] = useState(false);
  const [openIvrRouteDialog, setOpenIvrRouteDialog] = useState(false);

  const [qaTemplates, setQaTemplates] = useState([]);
  const [qaMetrics, setQaMetrics] = useState([]);
  const [metricName, setMetricName] = useState(null);
  const [templateName, setTemplateName] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [selectedMetric, setSelectedMetric] = useState(null);
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const [openMetricDialog, setOpenMetricDialog] = useState(false);
  const [openAttachTemplateMetric, setOpenAttachTemplateMetric] = useState(false);

  async function createQaTemplate() {
    if (!templateName) {
      setSeverity("error");
      setErrMsg("Name is required.");
      setOpen(true);
      return;
    }

    setOpenTemplateDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/qa/templates/create.json", {
        reference: ref,
        title: templateName,
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("Unable to attach metric.");
        setOpen(true);
      });
  }

  async function removeQaTemplate(templateRef) {
    if (!window.confirm("Remove this QA template from the call center?")) return;
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/qa/templates/${templateRef}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachQaTemplateMetric() {
    if (!selectedTemplate) {
      setSeverity("error");
      setErrMsg("Template is required.");
      setOpen(true);
      return;
    }

    if (!selectedMetric) {
      setSeverity("error");
      setErrMsg("Metric is required.");
      setOpen(true);
      return;
    }

    setOpenAttachTemplateMetric(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/qa/templates/metrics/create.json", {
        reference: selectedTemplate,
        metric: selectedMetric,
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("Unable to attach metric.");
        setOpen(true);
      });
  }

  async function removeQaTemplateMetric(metricRef) {
    if (!window.confirm("Remove this template metric?")) return;
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/qa/templates/metrics/${metricRef}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createQaMetric() {
    if (!metricName) {
      setSeverity("error");
      setErrMsg("Name is required.");
      setOpen(true);
      return;
    }

    setOpenMetricDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/qa/metrics/create.json", {
        reference: ref,
        title: metricName,
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("Unable to attach metric.");
        setOpen(true);
      });
  }

  async function removeQaMetric(metricRef) {
    if (!window.confirm("Remove this evaluation metric?")) return;
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/qa/metrics/${metricRef}/delete.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/voice/call_centers/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCurrency(result.data.currency);
            setResultData(result.data.data.campaign);
            setCallCenterCampaigns(result.data.data.call_center_campaigns || []);
            setCampaigns(result.data.data.campaigns || []);
            setCallCenter(result.data.data.center);
            setPhoneNumbers(result.data.data.phone_numbers);
            setCallCenterNumbers(result.data.data.call_center_numbers);
            setContacts(result.data.data.contact_count);
            setTags(result.data.data.tags);
            setCallOutcomes(result.data.data.outcomes);

            setOperatingHours(result.data.data.operating_hours);

            setVoicemailText(result.data.data.voicemail?.text);
            setVoicemailAudio(result.data.data.voicemail?.file);

            setWelcomeMessageText(result.data.data.welcome_message?.text);
            setWelcomeMessageAudio(result.data.data.welcome_message?.file);

            setAgentGroups(result.data.data.agent_groups);
            setCallCenterAgentGroups(result.data.data.call_center_groups);
            const rows = buildAgentGroupRows(result.data.data.call_center_groups);
            setTableRows(rows);

            setSubscription(result.data.data.subscription);
            setTiers(result.data.data.tiers);
            setAddons(result.data.data.addons);

            setIvr(result.data.data.ivr);
            setIvrMsg(result.data.data.ivr?.text);
            setIvrAudio(result.data.data.ivr?.file);

            if (result.data.data.qa) {
              setQaTemplates(result.data.data.qa.templates || []);
              setQaMetrics(result.data.data.qa.metrics || []);
            }

            setCallCenterWaccs(result.data.data.call_center_wacc_numbers || []);
            setWaccNumbers(result.data.data.wacc_business_numbers || []);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function attachCampaign() {
    if (!selectedCampaign) {
      setSeverity("error");
      setErrMsg("Select a campaign");
      setOpen(true);
      return;
    }

    setOpenAttachCampaignDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/campaigns/attach.json", {
        reference: ref,
        campaign: selectedCampaign,
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSelectedCampaign("");
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage((prev) => !prev);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to attach campaign. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeCampaign(campaignRef) {
    if (!window.confirm("Remove this campaign from the call center?")) return;
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/campaigns/${campaignRef}/remove.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage((prev) => !prev);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to remove campaign. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachWacc() {
    if (!selectedWacc) {
      setSeverity("error");
      setErrMsg("Select a whatsapp number");
      setOpen(true);
      return;
    }

    if (!waccTitle) {
      setSeverity("error");
      setErrMsg("Enter a connection name");
      setOpen(true);
      return;
    }

    setOpenAttachWaccDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/wacc/attach.json", {
        reference: ref,
        wacc: selectedWacc,
        title: waccTitle,
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSelectedCampaign("");
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage((prev) => !prev);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to attach campaign. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeWacc(waccRef) {
    if (!window.confirm("Remove this whatsapp number from the call center?")) return;
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/wacc/${waccRef}/remove.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage((prev) => !prev);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to remove campaign. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachBusinessNumber() {
    if (selectedNumber === null) {
      setSeverity("error");
      setErrMsg("Select a business number");
      setOpen(true);
      return;
    }

    setOpenAttachNumberDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      number: selectedNumber,
    };

    await axios
      .post("/portal/voice/call_centers/numbers/attach.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeBusinessNumber(numberRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/numbers/${numberRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateCallDirection(direction) {
    setShowLoading(true);
    const json = {
      reference: ref,
      type: direction,
    };

    await axios
      .post("/portal/voice/call_centers/direction/update.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgentGroup(groupRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/${groupRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteAgentGroupTag(tagRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/tags/${tagRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateAgentGroupStatus(groupRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/${groupRef}/status.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function updateAgentGroupDirection(groupRef, direction) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/groups/direction/${groupRef}/${direction}/update.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function assignAgentGroup() {
    if (selectedAgentGroup === null) {
      setSeverity("error");
      setErrMsg("An agent group is required.");
      setOpen(true);
      return;
    }

    setOpenNewAgentGroupDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      group: selectedAgentGroup,
      inbound: canReceive,
      outbound: canCall,
      tags: selectedTags,
    };

    await axios
      .post("/portal/voice/call_centers/groups/assign.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const agentGroupTableColumns = [
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Incoming", accessor: "inbound", align: "left" },
    { Header: "Outgoing", accessor: "outbound", align: "left" },
    { Header: "Tags", accessor: "tags", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildAgentGroupRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        name: row.title,
        inbound: (
          <MDBox>
            <Switch
              checked={row.can_receive}
              color="success"
              onChange={(e) => {
                updateAgentGroupDirection(row.reference, "inbound");
              }}
            />
          </MDBox>
        ),
        outbound: (
          <MDBox>
            <Switch
              checked={row.can_call}
              color="success"
              onChange={(e) => {
                updateAgentGroupDirection(row.reference, "outbound");
              }}
            />
          </MDBox>
        ),
        tags:
          row.tags.length > 0 ? (
            <MDBox display="flex" flexWrap="wrap" gap={0.5}>
              {row.tags.map((tag) => (
                <Chip
                  size="small"
                  key={tag.reference}
                  label={tag.title}
                  onDelete={() => {
                    if (window.confirm("Delete tag?") === true) {
                      deleteAgentGroupTag(tag.reference);
                    }
                  }}
                />
              ))}
            </MDBox>
          ) : (
            "---"
          ),
        status: (
          <MDBox>
            <Icon color={row.status ? "success" : "error"}>
              {row.status ? "check_circle" : "cancel"}
            </Icon>
          </MDBox>
        ),
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="info"
              iconOnly
              onClick={() => {
                if (window.confirm(`${row.status ? "Disable" : "Enable"} this group?`) === true) {
                  updateAgentGroupStatus(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                {row.status ? "pause" : "play_arrow"}
              </Icon>
            </MDButton>
            &nbsp; &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove this group?`) === true) {
                  deleteAgentGroup(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  const campaignTableColumns = [
    { Header: "Campaign", accessor: "title", align: "left" },
    { Header: "Type", accessor: "campaign_type", align: "left" },
    { Header: "Status", accessor: "status", align: "center" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignRows = (data) =>
    data.map((campaign) => ({
      title: campaign.title,
      campaign_type: campaign.campaign_type || "—",
      status: (
        <Chip
          label={campaign.status ? "Active" : "Inactive"}
          size="small"
          color={campaign.status ? "success" : "default"}
          variant={campaign.status ? "filled" : "outlined"}
        />
      ),
      actions: (
        <MDButton
          variant="outlined"
          color="error"
          size="small"
          onClick={() => removeCampaign(campaign.reference)}
          iconOnly
        >
          <Icon>delete</Icon>
        </MDButton>
      ),
    }));

  const waccTableColumns = [
    { Header: "Whatsapp Number", accessor: "phone_number", align: "left" },
    { Header: "Name", accessor: "name", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildWaccRows = (data) =>
    data.map((row) => ({
      phone_number: row.phone_number,
      name: row.title,
      actions: (
        <MDButton
          variant="outlined"
          color="error"
          size="small"
          onClick={() => removeWacc(row.reference)}
          iconOnly
        >
          <Icon>delete</Icon>
        </MDButton>
      ),
    }));

  async function deleteOutcome(outcomeRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/outcomes/${outcomeRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteTag(tagRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/tags/${tagRef}/remove.json`)
      .then(async (result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createTag() {
    setOpenTagDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: entityTitle,
    };

    await axios
      .post("/portal/voice/call_centers/tags/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createOutcome() {
    setOpenOutcomeDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      title: entityTitle,
    };

    await axios
      .post("/portal/voice/call_centers/outcomes/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  function downloadTemplate(headers, filename = "sample_upload.xlsx") {
    const worksheet = XLSX.utils.aoa_to_sheet([headers]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");
    XLSX.writeFile(workbook, filename);
  }

  async function fileSelected(e) {
    const fileTypes = ["xlsx", "xls", "csv"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only excel and csv files accepted.");
      setOpen(true);
      return;
    }

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data, { type: "array" });
      const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

      if (!json.length) {
        throw new Error("Empty file");
      }

      // First row = headers
      const headers = json[0].map((h) => String(h).toLowerCase().trim());
      const requiredColumns = ["name", "phone_number"];
      const missing = requiredColumns.filter((col) => !headers.includes(col));
      if (missing.length > 0) {
        setSeverity("error");
        setErrMsg(`Missing required columns: ${missing.join(", ")}`);
        setOpen(true);
        return;
      }

      setUploadFile(file);
    } catch (err) {
      setSeverity("error");
      setErrMsg("Invalid or unreadable file.");
      setOpen(true);
    }
  }

  async function uploadContacts() {
    if (!uploadFile) {
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (selectedTag) {
      formData.append("tag", selectedTag);
    }
    formData.append("file", uploadFile);

    // console.log(formData)
    setOpenUploadContactsDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/contacts/upload.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function subscribe() {
    if (selectedTier === null) {
      setSeverity("error");
      setErrMsg("A tier is required.");
      setOpen(true);
      return;
    }

    let tier = selectedTier;
    setSelectedTier(null);

    setOpenSubscriptionDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      tier: tier.reference,
      duration: subscriptionDuration,
    };

    await axios
      .post("/portal/voice/call_centers/subscription/subscribe.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function buyAddon(addon) {
    if (addon === null) {
      setSeverity("error");
      setErrMsg("An addon is required.");
      setOpen(true);
      return;
    }

    setOpenAddonDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      bundle: addon.reference,
    };

    await axios
      .post("/portal/voice/call_centers/addon/purchase.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function setVoicemailRecording(e) {
    const fileTypes = ["mp3", "wav"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only mp3 and wav files accepted.");
      setOpen(true);
      return;
    }

    setVoicemailMsg(null);
    setVoicemailFile(file);
  }

  async function setVoicemail() {
    if (!voicemailMsg && !voicemailFile) {
      setSeverity("error");
      setErrMsg("Voicemail message or pre-recorded audio file required.");
      setOpen(true);
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (voicemailMsg) {
      formData.append("text", voicemailMsg);
    }

    if (voicemailFile) {
      formData.append("file", voicemailFile);
    }

    // console.log(formData)
    setOpenVoicemailDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/voicemail/update.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function deleteVoicemail() {
    if (window.confirm("Delete voicemail?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/voicemail/${ref}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function setWelcomeMessageRecording(e) {
    const fileTypes = ["mp3", "wav"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only mp3 and wav files accepted.");
      setOpen(true);
      return;
    }

    setWelcomeMessageMsg(null);
    setWelcomeMessageFile(file);
  }

  async function setWelcomeMessage() {
    if (!welcomeMessageMsg && !welcomeMessageFile) {
      setSeverity("error");
      setErrMsg("Welcome message or pre-recorded audio file required.");
      setOpen(true);
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (welcomeMessageMsg) {
      formData.append("text", welcomeMessageMsg);
    }

    if (welcomeMessageFile) {
      formData.append("file", welcomeMessageFile);
    }

    // console.log(formData)
    setOpenWelcomeMessageDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/welcome_message/update.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function deleteWelcomeMessage() {
    if (window.confirm("Delete welcome message?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/welcome_message/${ref}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  function generateTimeArray() {
    const startTime = new Date();
    const endTime = new Date();
    startTime.setHours(0, 0, 0, 0);
    endTime.setHours(23, 59, 0, 0);

    const timeArray = [];
    const currentTime = new Date(startTime);

    while (currentTime <= endTime) {
      const hours = String(currentTime.getHours()).padStart(2, "0");
      const minutes = String(currentTime.getMinutes()).padStart(2, "0");
      timeArray.push(`${hours}:${minutes}`);
      currentTime.setMinutes(currentTime.getMinutes() + 30);
    }

    return timeArray;
  }
  const timeArray = generateTimeArray();

  async function saveOperationEntry() {
    if (operatingDay.length <= 0) {
      setSeverity("error");
      setErrMsg("A week day is required.");
      setOpen(true);
      return;
    }

    if (operatingDirection.length <= 0) {
      setSeverity("error");
      setErrMsg("Call direction is required.");
      setOpen(true);
      return;
    }

    if (operatingStart === null) {
      setSeverity("error");
      setErrMsg("Select an opening hour.");
      setOpen(true);
      return;
    }

    if (operatingEnd === null) {
      setSeverity("error");
      setErrMsg("Select a closing hour.");
      setOpen(true);
      return;
    }

    setOpenOperatingHoursDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      week_day: operatingDay,
      direction: operatingDirection,
      open: operatingStart,
      close: operatingEnd,
      enabled: operatingEnabled,
      group: operatingGroup,
    };

    await axios
      .post("/portal/voice/call_centers/operating_hours/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function deleteOperatingRecord(recordRef) {
    if (window.confirm("Delete record?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/operating_hours/${recordRef}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  const WEEK_DAYS = ["MONDAY", "TUESDAY", "WEDNESDAY", "THURSDAY", "FRIDAY", "SATURDAY", "SUNDAY"];
  const orderedOperatingHours = WEEK_DAYS.filter((day) => operatingHours?.[day]).map((day) => [
    day,
    operatingHours[day],
  ]);

  async function setIvrlRecording(e) {
    const fileTypes = ["mp3", "wav"];
    const file = e.target.files[0];
    if (!file) return;

    const extension = file.name.split(".").pop().toLowerCase();
    const supported = fileTypes.includes(extension);
    if (!supported) {
      setSeverity("error");
      setErrMsg("Only mp3 and wav files accepted.");
      setOpen(true);
      return;
    }

    setIvrText(null);
    setIvrFile(file);
  }

  async function saveIvr() {
    if (!ivrText && !ivrFile) {
      setSeverity("error");
      setErrMsg("IVR message or pre-recorded audio file required.");
      setOpen(true);
      return;
    }

    const formData = new FormData();
    formData.append("reference", ref);
    if (ivrText) {
      formData.append("text", ivrText);
    }

    if (ivrFile) {
      formData.append("file", ivrFile);
    }

    // console.log(formData)
    setOpenIvrDialog(false);
    setShowLoading(true);
    await axios
      .post("/portal/voice/call_centers/ivr/update.json", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function deleteIvr() {
    if (window.confirm("Delete IVR?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/ivr/${ref}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function deleteIvrRoute(routeRef) {
    if (window.confirm("Delete IVR Route?") === false) {
      return;
    }

    setShowLoading(true);
    await axios
      .get(`/portal/voice/call_centers/ivr/routes/${routeRef}/delete.json`)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
        setShowLoading(false);
      });
  }

  async function createIvrRoute() {
    if (selectedAgentGroup === null) {
      setSeverity("error");
      setErrMsg("Agent group is required.");
      setOpen(true);
      return;
    }

    if (ivrDMFT === null) {
      setSeverity("error");
      setErrMsg("DTMF is required.");
      setOpen(true);
      return;
    }

    setOpenIvrRouteDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      group: selectedAgentGroup,
      dmtf: ivrDMFT,
    };

    await axios
      .post("/portal/voice/call_centers/ivr/routes/create.json", json)
      .then(async (result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          await statusDialog.show(result.data.data.message, "success", "Success!");
          setRefreshPage(!refreshPage);
        } else {
          await statusDialog.show(result.data.data.message, "error", "Action Failed!");
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>

      <Dialog
        open={openAttachWaccDialog}
        onClose={() => setOpenAttachWaccDialog(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Attach Whatsapp Number</DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <MDInput
              label="Connection Name"
              fullWidth
              onChange={(e) => {
                setWaccTitle(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mt={2}>
            <FormControl fullWidth>
              <InputLabel id="wacc-select-label">Whatsapp Number</InputLabel>
              <Select
                labelId="wacc-select-label"
                label="Whatsapp Number"
                value={selectedWacc}
                onChange={(e) => setSelectedWacc(e.target.value)}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                {waccNumbers.map((number) => (
                  <MenuItem key={number.reference} value={number.reference}>
                    {number.title} - {number.phone_number}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {waccNumbers.length === 0 && (
              <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 2 }}>
                There are no available whatsapp numbers to attach.
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenAttachWaccDialog(false)} color="dark" variant="outlined">
            Cancel
          </MDButton>
          <MDButton onClick={attachWacc} color="dark" variant="contained" disabled={!selectedWacc}>
            Attach Whatsapp Number
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openAttachTemplateMetric} fullWidth maxWidth="xs">
        <DialogTitle>Attach Evaluation Metric</DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <TextField
              select
              fullWidth
              label="Evaluation Metric"
              onChange={(e) => setSelectedMetric(e.target.value)}
              SelectProps={{ style: { padding: "12px 0px" } }}
            >
              {
                // --> Notice below changes
                qaMetrics.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                  qaMetrics.map((record) => (
                    <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                  ))
              }
            </TextField>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => setOpenAttachTemplateMetric(false)}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="dark"
            onClick={() => {
              attachQaTemplateMetric();
            }}
          >
            Attach Metric
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openTemplateDialog}
        onClose={() => setOpenTemplateDialog(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Create Evaluation Template</DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <MDInput
              label="Name"
              fullWidth
              onChange={(e) => {
                setTemplateName(e.target.value);
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={() => setOpenTemplateDialog(false)} color="dark" variant="outlined">
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="dark"
            onClick={() => {
              createQaTemplate();
            }}
          >
            Create Template
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openMetricDialog}
        onClose={() => setOpenMetricDialog(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Create Evaluation Metric</DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <MDInput
              label="Name"
              fullWidth
              onChange={(e) => {
                setIvrFile(null);
                setMetricName(e.target.value);
              }}
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="outlined" color="dark" onClick={() => setOpenMetricDialog(false)}>
            Cancel
          </MDButton>
          <MDButton
            variant="contained"
            color="dark"
            onClick={() => {
              createQaMetric();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>

      <Dialog open={openIvrRouteDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Call Route</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={5}>
            <MDBox mt={1}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>DTMF (Routing Digits)</InputLabel>
                <Select
                  label="DTMF (Routing Digits)"
                  onChange={(e) => {
                    setIvrDMFT(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="*">*</MenuItem>
                  <MenuItem value="#">#</MenuItem>
                  <MenuItem value="1">1</MenuItem>
                  <MenuItem value="2">2</MenuItem>
                  <MenuItem value="3">3</MenuItem>
                  <MenuItem value="4">4</MenuItem>
                  <MenuItem value="5">5</MenuItem>
                  <MenuItem value="6">6</MenuItem>
                  <MenuItem value="7">7</MenuItem>
                  <MenuItem value="8">8</MenuItem>
                  <MenuItem value="9">9</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group</InputLabel>
                <Select
                  label="Agent Group"
                  onChange={(e) => {
                    setSelectedAgentGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    callCenterAgentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      callCenterAgentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenIvrRouteDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createIvrRoute();
            }}
          >
            Create Route
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openIvrDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set IVR</MDBox>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info">
            <MDTypography fontSize={12}>
              Set a message that will be said to customers or a pre-recorded audio that will be
              played to your customers.
            </MDTypography>
          </Alert>
          <MDBox mt={3}>
            <MDInput
              label="IVR Message"
              fullWidth
              multiline
              minRows={2}
              onChange={(e) => {
                setIvrFile(null);
                setIvrText(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mt={3}>
            <TextField
              accept=".mp3, .wav"
              type="file"
              name="upload_file"
              id="upload_file"
              onChange={(e) => setIvrlRecording(e)}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenIvrDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              saveIvr();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openWelcomeMessageDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set Welcome Message</MDBox>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info">
            <MDTypography fontSize={12}>
              Set a message that will be said to customers or a pre-recorded audio that will be
              played to your customers.
            </MDTypography>
          </Alert>
          <MDBox mt={3}>
            <MDInput
              label="Welcome Message"
              fullWidth
              multiline
              minRows={2}
              onChange={(e) => {
                setWelcomeMessageFile(null);
                setWelcomeMessageMsg(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mt={3}>
            <TextField
              accept=".mp3, .wav"
              type="file"
              name="upload_file"
              id="upload_file"
              onChange={(e) => setWelcomeMessageRecording(e)}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenWelcomeMessageDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              setWelcomeMessage();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openVoicemailDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set Voicemail</MDBox>
        </DialogTitle>
        <DialogContent>
          <Alert severity="info">
            <MDTypography fontSize={12}>
              Set a message that will be said to customers or a pre-recorded audio that will be
              played to your customers.
            </MDTypography>
          </Alert>
          <MDBox mt={3}>
            <MDInput
              label="Voicemail Message"
              fullWidth
              multiline
              minRows={2}
              onChange={(e) => {
                setVoicemailFile(null);
                setVoicemailMsg(e.target.value);
              }}
            />
          </MDBox>
          <MDBox mt={3}>
            <TextField
              accept=".mp3, .wav"
              type="file"
              name="upload_file"
              id="upload_file"
              onChange={(e) => setVoicemailRecording(e)}
              fullWidth
            />
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenVoicemailDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              setVoicemail();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openOperatingHoursDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Set Operating Hours</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1}>
            <FormControl fullWidth>
              <InputLabel>Day Of Week</InputLabel>
              <Select
                multiple
                value={operatingDay}
                label="Day Of Week"
                onChange={(e) => {
                  setOperatingDay(e.target.value);
                }}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value="MONDAY">Monday</MenuItem>
                <MenuItem value="TUESDAY">Tuesday</MenuItem>
                <MenuItem value="WEDNESDAY">Wednesday</MenuItem>
                <MenuItem value="THURSDAY">Thursday</MenuItem>
                <MenuItem value="FRIDAY">Friday</MenuItem>
                <MenuItem value="SATURDAY">Saturday</MenuItem>
                <MenuItem value="SUNDAY">Sunday</MenuItem>
              </Select>
            </FormControl>
          </MDBox>

          <MDBox mt={3}>
            <FormControl fullWidth>
              <InputLabel>Call Direction</InputLabel>
              <Select
                multiple
                value={operatingDirection}
                label="Call Direction"
                onChange={(e) => {
                  setOperatingDirection(e.target.value);
                }}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip key={value} label={value} size="small" />
                    ))}
                  </Box>
                )}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value="inbound">Inbound</MenuItem>
                <MenuItem value="outbound">Outbound</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          <MDBox mt={3}>
            <FormControl fullWidth>
              <InputLabel>Call Status</InputLabel>
              <Select
                value={operatingEnabled}
                label="Call Status"
                onChange={(e) => {
                  setOperatingEnabled(e.target.value);
                }}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                <MenuItem value={true}>Calls Enabled</MenuItem>
                <MenuItem value={false}>Calls Disabled</MenuItem>
              </Select>
            </FormControl>
          </MDBox>
          <MDBox mt={3}>
            <Grid container spacing={3}>
              <Grid item xs={6} md={6} lg={6}>
                <MDBox>
                  <FormControl fullWidth>
                    <InputLabel>Opening Time</InputLabel>
                    <Select
                      label="Opening Time"
                      onChange={(e) => {
                        setOperatingStart(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      {timeArray.map((row) => (
                        <MenuItem value={row}>{row}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
              </Grid>
              <Grid item xs={6} md={6} lg={6}>
                <MDBox>
                  <FormControl fullWidth>
                    <InputLabel>Closing Time</InputLabel>
                    <Select
                      label="Closing Time"
                      onChange={(e) => {
                        setOperatingEnd(e.target.value);
                      }}
                      sx={{ padding: "12px", paddingLeft: "3px" }}
                    >
                      {timeArray.map((row) => (
                        <MenuItem value={row}>{row}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>

          {callCenterAgentGroups.length > 0 && (
            <MDBox mt={4}>
              <FormControl fullWidth>
                <InputLabel>Apply To Agent Group (Optional)</InputLabel>
                <Select
                  multiple
                  value={operatingGroup}
                  label="Apply To Agent Group (Optional)"
                  onChange={(e) => {
                    setOperatingGroup(e.target.value);
                  }}
                  renderValue={(selected) => (
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 0.5,
                      }}
                    >
                      {selected.map((id) => (
                        <Chip
                          key={id}
                          size="small"
                          label={callCenterAgentGroups.find((g) => g.reference === id)?.title || id}
                        />
                      ))}
                    </Box>
                  )}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {callCenterAgentGroups.map((record) => (
                    <MenuItem key={record.reference} value={record.reference}>
                      {record.title}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </MDBox>
          )}
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenOperatingHoursDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              saveOperationEntry();
            }}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openAttachCampaignDialog}
        onClose={() => setOpenAttachCampaignDialog(false)}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Attach Campaign</DialogTitle>
        <DialogContent>
          <MDBox mt={2}>
            <FormControl fullWidth>
              <InputLabel id="campaign-select-label">Campaign</InputLabel>
              <Select
                labelId="campaign-select-label"
                label="Campaign"
                value={selectedCampaign}
                onChange={(e) => setSelectedCampaign(e.target.value)}
                sx={{ padding: "12px", paddingLeft: "3px" }}
              >
                {campaigns.map((campaign) => (
                  <MenuItem key={campaign.reference} value={campaign.reference}>
                    {campaign.title}
                    {campaign.campaign_type ? ` (${campaign.campaign_type})` : ""}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {campaigns.length === 0 && (
              <MDTypography variant="caption" color="text" sx={{ display: "block", mt: 2 }}>
                There are no available campaigns to attach.
              </MDTypography>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => setOpenAttachCampaignDialog(false)}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            onClick={attachCampaign}
            color="dark"
            variant="contained"
            disabled={!selectedCampaign}
          >
            Attach Campaign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAttachNumberDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Business Number</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Business Number</InputLabel>
                <Select
                  label="Business Number"
                  onChange={(e) => {
                    setSelectedNumber(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    phoneNumbers.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      phoneNumbers.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachNumberDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              attachBusinessNumber();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openNewAgentGroupDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Assign Agent Group</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={5}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Agent Group</InputLabel>
                <Select
                  label="Agent Group"
                  onChange={(e) => {
                    setSelectedAgentGroup(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    agentGroups.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      agentGroups.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={canCall}
                onChange={(e) => {
                  setCanCall(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Allow Outbound Calls
              </MDTypography>
            </MDBox>
            <MDBox mt={3} display="flex" alignItems="center" ml={-1}>
              <Checkbox
                checked={canReceive}
                onChange={(e) => {
                  setCanReceive(e.target.checked);
                }}
                inputProps={{ "aria-label": "controlled" }}
              />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Allow Inbound Calls
              </MDTypography>
            </MDBox>
            {tags.length > 0 && (
              <MDBox mt={4}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Contact Tags (Optional)</InputLabel>
                  <Select
                    label="Contact Tags (Optional)"
                    multiple
                    value={selectedTags}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSelectedTags(typeof value === "string" ? value.split(",") : value);
                    }}
                    renderValue={(selectedValues) => (
                      <Box display="flex" flexWrap="wrap" gap={0.5}>
                        {selectedValues.map((val) => {
                          const item = tags.find((o) => o.reference === val);
                          return <Chip key={val} label={item?.title || val} />;
                        })}
                      </Box>
                    )}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                  >
                    {
                      // --> Notice below changes
                      tags.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        tags.map((record) => (
                          <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                        ))
                    }
                  </Select>
                </FormControl>
              </MDBox>
            )}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenNewAgentGroupDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              assignAgentGroup();
            }}
          >
            Assign
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openOutcomeDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Call Outcome</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <MDInput
                fullWidth
                label="Outcome Name"
                onChange={(e) => setEntityTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenOutcomeDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createOutcome();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openTagDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Create Contact Tag</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox>
            <MDBox mt={2}>
              <MDInput
                fullWidth
                label="Contact Tag"
                onChange={(e) => setEntityTitle(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenTagDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createTag();
            }}
          >
            Create
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openUploadContactsDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Upload Contacts</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={1} mb={3}>
            <MDBox>
              <TextField
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                type="file"
                name="upload_file"
                id="upload_file"
                onChange={(e) => fileSelected(e)}
                fullWidth
              />
            </MDBox>
            <MDBox mt={1}>
              <Alert severity="warning">
                <MDTypography variant="subtitle2" fontSize={14} mb={1}>
                  Download sample upload template.
                </MDTypography>
                <MDButton
                  size="small"
                  variant="contained"
                  color="dark"
                  onClick={() => {
                    let headers = ["name", "phone_number"];
                    downloadTemplate(headers, "sample_entity_upload.xlsx");
                  }}
                >
                  Sample Template
                </MDButton>
              </Alert>
            </MDBox>

            <MDBox mt={4}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Contact Tag (Optional)</InputLabel>
                <Select
                  label="Contact Tag (Optional)"
                  onChange={(e) => {
                    setSelectedTag(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    tags.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      tags.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenUploadContactsDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              uploadContacts();
            }}
          >
            Upload
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openSubscriptionDialog} fullWidth maxWidth="lg">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6" fontSize={24}>
              Subscription Plans
            </MDTypography>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              Choose the right plan for your business.
            </MDTypography>
          </MDBox>
          <MDBox>
            <Divider />
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox>
              <Grid container spacing={3} alignItems="stretch">
                {tiers.map((tier) => (
                  <Grid
                    item
                    xs={12}
                    md={4}
                    lg={4}
                    key={tier.title}
                    sx={{
                      display: "flex",
                    }}
                  >
                    <Paper
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <MDBox
                        py={2}
                        px={1}
                        align="center"
                        sx={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        {/* Header */}
                        <MDBox>
                          <MDTypography variant="h6">{tier.title}</MDTypography>

                          <MDTypography fontSize={15}>
                            {`${currency}${(tier.price / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}`}
                          </MDTypography>

                          <MDTypography fontSize={9}>
                            {`${currency}${(tier.vat / 100).toLocaleString("en", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })} VAT`}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <Divider />
                        </MDBox>

                        {/* Features */}
                        <MDBox
                          mt={1}
                          sx={{
                            flexGrow: 1,
                            width: "100%",
                          }}
                        >
                          <Table>
                            <TableRow>
                              <TableCell>
                                <MDTypography fontSize={12}>Business Numbers</MDTypography>
                              </TableCell>

                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {tier.numbers}
                                </MDTypography>
                              </TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>
                                <MDTypography fontSize={12}>Concurrency</MDTypography>
                              </TableCell>

                              <TableCell>
                                <MDTypography align="right" fontSize={12}>
                                  {tier.calls} calls
                                </MDTypography>
                              </TableCell>
                            </TableRow>

                            {tier.bundles.map((addon) => (
                              <TableRow key={addon.addon}>
                                <TableCell>
                                  <MDTypography fontSize={12}>{addon.addon}</MDTypography>
                                </TableCell>

                                <TableCell>
                                  <MDTypography align="right" fontSize={12}>
                                    {addon.title}
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            ))}

                            {tier.features.map((feature) => (
                              <TableRow key={feature}>
                                <TableCell>
                                  <MDTypography fontSize={12}>{feature}</MDTypography>
                                </TableCell>

                                <TableCell>
                                  <MDTypography align="right" fontSize={12}>
                                    <Icon color="success">check_circle</Icon>
                                  </MDTypography>
                                </TableCell>
                              </TableRow>
                            ))}
                          </Table>
                        </MDBox>

                        {/* Select button */}
                        <MDBox mt={3}>
                          <MDBox>
                            <MDTypography variant="caption">30-day billing cycle</MDTypography>
                          </MDBox>
                          <MDBox mt={1}>
                            <MDButton
                              color="dark"
                              variant="contained"
                              onClick={() => {
                                setSubscriptionDuration(1);
                                setSelectedTier(tier);
                              }}
                            >
                              Select
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSubscriptionDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddonDialog} fullWidth maxWidth="md">
        <DialogTitle>
          <MDBox align="center" mb={1}>
            <MDTypography variant="h6">Add Ons</MDTypography>
            <MDTypography variant="h6" fontSize={14} fontWeight="light">
              Purchase add-on packs for your use case.
            </MDTypography>
          </MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mb={3}>
            <MDBox>
              <Grid container spacing={3}>
                {addons.map((add) => (
                  <Grid item xs={12} md={3} lg={3}>
                    <Paper>
                      <MDBox py={2} align="center">
                        <MDBox>
                          <MDTypography variant="caption">{add.addon}</MDTypography>
                          <MDTypography variant="h6">{add.title}</MDTypography>
                          <MDTypography fontSize={15}>{`${currency}${(
                            add.price / 100
                          ).toLocaleString("en", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}`}</MDTypography>
                        </MDBox>
                        <MDBox mt={3}>
                          <MDButton
                            color="dark"
                            variant="contained"
                            onClick={() => {
                              buyAddon(add);
                            }}
                            size="small"
                          >
                            Buy
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddonDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
        </DialogActions>
      </Dialog>
      {selectedTier && (
        <Dialog open fullWidth maxWidth="xs">
          <DialogTitle>
            <MDTypography align="center" variant="body2" fontSize={14}>
              Capacity Tier
            </MDTypography>
            <MDTypography align="center" variant="h6">
              {selectedTier.title}
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            <MDBox>
              <MDBox mt={1}>
                <FormControl sx={{ minWidth: 120, width: "100%" }}>
                  <InputLabel>Duration</InputLabel>
                  <Select
                    label="Duration"
                    onChange={(e) => {
                      setSubscriptionDuration(e.target.value);
                    }}
                    sx={{ padding: "12px", paddingLeft: "3px" }}
                    value={subscriptionDuration}
                  >
                    <MenuItem value={1}>30 days</MenuItem>
                    <MenuItem value={3}>90 days</MenuItem>
                    <MenuItem value={6}>180 days</MenuItem>
                    <MenuItem value={12}>365 days</MenuItem>
                  </Select>
                </FormControl>
              </MDBox>
              <MDBox mt={3}>
                <Table>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={12}>Price</MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontSize={12}>
                        {currency}
                        {((selectedTier.price / 100) * subscriptionDuration).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={12}>VAT</MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontSize={12}>
                        {currency}
                        {((selectedTier.vat / 100) * subscriptionDuration).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>
                      <MDTypography>
                        <MDTypography fontSize={14} fontWeight="bold">
                          Total
                        </MDTypography>
                      </MDTypography>
                    </TableCell>
                    <TableCell>
                      <MDTypography align="right" fontWeight="bold" fontSize={14}>
                        {currency}
                        {(
                          ((selectedTier.price + selectedTier.vat) / 100) *
                          subscriptionDuration
                        ).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </TableCell>
                  </TableRow>
                </Table>
              </MDBox>
            </MDBox>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setSelectedTier(null);
              }}
              color="dark"
              variant="outlined"
              startIcon={<Icon>west</Icon>}
            >
              Back
            </MDButton>
            <MDButton
              onClick={() => {
                subscribe();
              }}
              color="dark"
              variant="contained"
            >
              Activate
            </MDButton>
          </DialogActions>
        </Dialog>
      )}
      <MDBox mt={0.5} mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={0} mb={2} display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    navigate(`/voice/call-centers`);
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox display="flex" gap={1}>
                <MDButton
                  size="small"
                  color="success"
                  variant="contained"
                  onClick={() => {
                    navigate(`/voice/call-centers/live-view/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      preview
                    </Icon>
                  }
                >
                  Live View
                </MDButton>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/call-centers/calls/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      list_alt
                    </Icon>
                  }
                >
                  Call Logs
                </Button>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/call-centers/insights/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      leaderboard
                    </Icon>
                  }
                >
                  Insights
                </Button>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/voice/call-centers/performance/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      people
                    </Icon>
                  }
                >
                  Performance
                </Button>
              </MDBox>
            </MDBox>

            <MDBox mt={2}>
              <MDBox>
                {subscription ? (
                  <MDBox>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={4} lg={4}>
                        <Card sx={{ height: "100%" }}>
                          <MDBox align="center" p={2} sx={{ height: "100%" }}>
                            <MDTypography fontSize={42}>
                              <Icon color="success">check_circle</Icon>
                            </MDTypography>
                            <MDBox mt={-2}>
                              <ListItemText
                                primary={<MDTypography variant="caption">Tier</MDTypography>}
                                secondary={
                                  <MDTypography variant="h6">{subscription.tier}</MDTypography>
                                }
                              />
                            </MDBox>
                            <MDBox mt={1}>
                              <MDTypography variant="caption">Expires On</MDTypography>
                              <MDTypography fontSize={14}>{subscription.end}</MDTypography>
                            </MDBox>
                            <MDBox mt={2} align="center">
                              <MDButton
                                variant="contained"
                                color="dark"
                                size="small"
                                startIcon={<Icon>money</Icon>}
                                onClick={() => {
                                  setSelectedTier(null);
                                  setSubscriptionDuration(1);
                                  setOpenSubscriptionDialog(true);
                                }}
                              >
                                Change Plan
                              </MDButton>
                            </MDBox>
                          </MDBox>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={8} lg={8}>
                        <Card sx={{ height: "100%" }}>
                          <MDBox p={2} sx={{ height: "100%" }}>
                            <MDBox mb={3} display="flex" justifyContent="space-between">
                              <MDBox mt={1}>
                                <MDTypography variant="h6" fontWeight={600} mb={1}>
                                  Add Ons
                                </MDTypography>
                              </MDBox>
                              <MDBox>
                                <MDButton
                                  color="dark"
                                  variant="contained"
                                  size="small"
                                  iconOnly
                                  onClick={() => setOpenAddonDialog(true)}
                                >
                                  <Icon>add</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                            {subscription.addons.map((addon) => {
                              let progress = ((addon.balance / addon.total) * 100).toFixed(0);

                              function getColor() {
                                let color = "success.main";
                                if (progress < 60) {
                                  color = "warning.main";
                                }

                                if (progress <= 30) {
                                  color = "error.main";
                                }

                                return color;
                              }
                              return (
                                <Box mb={3}>
                                  <MDBox display="flex" justifyContent="space-between">
                                    <MDTypography
                                      variant="h6"
                                      align="right"
                                      fontWeight="regular"
                                      mb={1}
                                    >
                                      {addon.title}
                                    </MDTypography>
                                    <MDTypography
                                      variant="body2"
                                      align="right"
                                      fontWeight={600}
                                      mb={1}
                                    >
                                      {`${100 - progress}%`} used
                                    </MDTypography>
                                  </MDBox>

                                  <Box
                                    sx={{
                                      height: 6,
                                      borderRadius: 4,
                                      backgroundColor: "#e0e0e0",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        width: `${100 - progress}%`,
                                        height: "100%",
                                        backgroundColor: getColor,
                                        transition: "width 0.4s ease",
                                      }}
                                    />
                                  </Box>
                                </Box>
                              );
                            })}
                          </MDBox>
                        </Card>
                      </Grid>
                    </Grid>
                  </MDBox>
                ) : (
                  <Card>
                    <MDBox p={2}>
                      <MDBox align="center">
                        <MDTypography variant="h6" fontSize={48}>
                          <Icon color="error">warning</Icon>
                        </MDTypography>
                        <MDTypography variant="h6" fontSize={14} fontWeight="light">
                          No active subscription plan!
                        </MDTypography>
                        <MDBox>
                          <Divider />
                        </MDBox>
                        <MDBox mt={2} align="center">
                          <MDButton
                            variant="contained"
                            color="dark"
                            startIcon={<Icon>money</Icon>}
                            onClick={() => {
                              setSelectedTier(null);
                              setSubscriptionDuration(1);
                              setOpenSubscriptionDialog(true);
                            }}
                          >
                            Buy a Plan
                          </MDButton>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                )}
              </MDBox>
            </MDBox>

            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox>
                            <MDTypography variant="h6" fontWeight="light" fontSize={13}>
                              Call Center
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="bold" fontSize={16}>
                              {callCenter.title}
                            </MDTypography>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            <MDBox>
                              <FormControlLabel
                                fullWidth
                                control={
                                  <Switch
                                    checked={callCenter.can_receive}
                                    onChange={() => updateCallDirection("incoming")}
                                  />
                                }
                                label="Incoming Calls"
                              />
                            </MDBox>
                            {callCenter.can_receive && (
                              <MDBox mt={2}>
                                <ListItem>
                                  <ListItemText
                                    primary={
                                      <MDTypography variant="body2" fontWeight="bold">
                                        Incoming Termination
                                      </MDTypography>
                                    }
                                    secondary={
                                      <MDTypography
                                        variant="body2"
                                        fontWeight="regular"
                                        fontSize={12}
                                      >
                                        {callCenter.inbound_destination === "DIALER"
                                          ? "Ring in Dialer Client"
                                          : "Ring on Agent Phone Number"}
                                      </MDTypography>
                                    }
                                  />
                                  <MDBox>
                                    <Tooltip
                                      title={
                                        callCenter.inbound_destination === "DIALER"
                                          ? "Switch to Number"
                                          : "Switch to Dialer"
                                      }
                                    >
                                      <MDButton
                                        iconOnly
                                        variant="outlined"
                                        color="dark"
                                        onClick={() => updateCallDirection("inbound_destination")}
                                        size="small"
                                      >
                                        <Icon>swap_calls</Icon>
                                      </MDButton>
                                    </Tooltip>
                                  </MDBox>
                                </ListItem>
                              </MDBox>
                            )}

                            <Divider />
                            <MDBox mt={2}>
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={callCenter.can_call}
                                    onChange={() => updateCallDirection("outgoing")}
                                  />
                                }
                                label="Outgoing Calls"
                              />
                            </MDBox>
                            {callCenter.can_call && (
                              <MDBox mt={2}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={callCenter.allow_dial_pad}
                                      onChange={() => updateCallDirection("dial_pad")}
                                    />
                                  }
                                  label="Allow Open Dialing (Dial Pad)"
                                />
                              </MDBox>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                Business Numbers
                              </MDTypography>
                            </MDBox>
                            <MDBox mt={-1}>
                              <MDButton
                                size="small"
                                variant="contained"
                                color="dark"
                                iconOnly
                                onClick={() => {
                                  setSelectedNumber(null);
                                  setOpenAttachNumberDialog(true);
                                }}
                              >
                                <Icon>add</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            {callCenterNumbers.length > 0 ? (
                              <MDBox>
                                {callCenterNumbers.map((n) => (
                                  <ListItem divider>
                                    <ListItemText
                                      primary={
                                        <MDTypography mb={2} variant="caption" fontSize={13}>
                                          {n.phone_number}
                                        </MDTypography>
                                      }
                                    />
                                    <MDBox mb={1}>
                                      <MDButton
                                        size="small"
                                        variant="outlined"
                                        color="error"
                                        iconOnly
                                        onClick={() => {
                                          removeBusinessNumber(n.reference);
                                        }}
                                      >
                                        <Icon>delete</Icon>
                                      </MDButton>
                                    </MDBox>
                                  </ListItem>
                                ))}
                              </MDBox>
                            ) : (
                              <MDTypography
                                align="center"
                                variant="h6"
                                fontWeight="light"
                                fontSize={13}
                              >
                                No business numbers added.
                              </MDTypography>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={4} lg={4}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox
                            mt={1}
                            mb={2}
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                          >
                            <MDBox>
                              <MDTypography variant="h6" fontWeight="regular" fontSize={13}>
                                Contacts
                              </MDTypography>
                            </MDBox>
                            <MDBox mt={-1} display="flex" gap={0.5}>
                              <Tooltip title="Upload Contacts">
                                <MDButton
                                  size="small"
                                  variant="contained"
                                  color="dark"
                                  iconOnly
                                  onClick={() => {
                                    setSelectedTag(null);
                                    setUploadFile(null);
                                    setOpenUploadContactsDialog(true);
                                  }}
                                >
                                  <Icon>upload</Icon>
                                </MDButton>
                              </Tooltip>
                              <Tooltip title="Manage Contacts">
                                <MDButton
                                  size="small"
                                  variant="contained"
                                  color="dark"
                                  iconOnly
                                  onClick={() => {
                                    navigate(`/voice/call-centers/${ref}/contacts`);
                                  }}
                                >
                                  <Icon>settings</Icon>
                                </MDButton>
                              </Tooltip>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            <Divider />
                          </MDBox>
                          <MDBox mt={3} mb={3}>
                            <MDBox align="center">
                              <MDTypography variant="h6" fontSize={36}>
                                {contacts.toLocaleString("en-US", {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 0,
                                })}
                              </MDTypography>
                              <MDTypography mt={2} variant="h6" fontWeight="light" fontSize={13}>
                                Contacts
                              </MDTypography>
                            </MDBox>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox mb={2} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6">Call Outcomes (Dispositions)</MDTypography>
                            </MDBox>
                            <MDBox mt={-1}>
                              <MDButton
                                size="small"
                                variant="contained"
                                color="dark"
                                iconOnly
                                onClick={() => {
                                  setEntityTitle(null);
                                  setOpenOutcomeDialog(true);
                                }}
                              >
                                <Icon>add</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            {callOutcomes.length > 0 ? (
                              <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                {callOutcomes.map((outcome) => (
                                  <Chip
                                    key={outcome.reference}
                                    label={outcome.title}
                                    onDelete={() => {
                                      if (window.confirm("Delete record?") === true) {
                                        deleteOutcome(outcome.reference);
                                      }
                                    }}
                                  />
                                ))}
                              </MDBox>
                            ) : (
                              <MDBox>
                                <MDTypography variant="body2" fontSize={13}>
                                  No call outcomes have been added.
                                </MDTypography>
                              </MDBox>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <MDBox sx={{ height: "100%", marginTop: "0px" }}>
                    <Card sx={{ height: "100%", marginTop: "0px" }}>
                      <MDBox p={2}>
                        <MDBox>
                          <MDBox mb={2} display="flex" justifyContent="space-between">
                            <MDBox>
                              <MDTypography variant="h6">Contact Tags</MDTypography>
                            </MDBox>
                            <MDBox mt={-1}>
                              <MDButton
                                size="small"
                                variant="contained"
                                color="dark"
                                iconOnly
                                onClick={() => {
                                  setEntityTitle(null);
                                  setOpenTagDialog(true);
                                }}
                              >
                                <Icon>add</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          <MDBox>
                            {tags.length > 0 ? (
                              <MDBox display="flex" flexWrap="wrap" gap={0.5}>
                                {tags.map((tag) => (
                                  <Chip
                                    key={tag.reference}
                                    label={tag.title}
                                    onDelete={() => {
                                      if (window.confirm("Delete record?") === true) {
                                        deleteTag(tag.reference);
                                      }
                                    }}
                                  />
                                ))}
                              </MDBox>
                            ) : (
                              <MDBox>
                                <MDTypography variant="body2" fontSize={13}>
                                  No contact tags have been added.
                                </MDTypography>
                              </MDBox>
                            )}
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </Card>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="light">
                        <b>Agent Groups</b>
                        <br />
                        <small>
                          Manage your call agents. Add agent groups, set call capabilities and
                          assign contact tags.
                        </small>
                      </MDTypography>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedAgentGroup(null);
                          setSelectedTags([]);
                          setOpenNewAgentGroupDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <DataTable
                      table={{ columns: agentGroupTableColumns, rows: tableRows }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={6}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">Welcome Message</MDTypography>
                        <Divider />
                      </MDBox>
                      <MDBox mt={2}>
                        {welcomeMessageText || welcomeMessageAudio ? (
                          <MDBox>
                            {welcomeMessageText && (
                              <MDInput
                                fullWidth
                                InputProps={{
                                  readOnly: true,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon fontSize="small">volume_up</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                value={welcomeMessageText}
                              />
                            )}
                            {welcomeMessageAudio && (
                              <audio
                                src={`${AppConfig.api_media_url}${welcomeMessageAudio}`}
                                controls
                              >
                                Your browser does not support the audio element.
                              </audio>
                            )}
                          </MDBox>
                        ) : (
                          <MDBox>
                            <MDTypography variant="body2" fontSize={14}>
                              Set a welcome message to play to your customers on incoming calls.
                            </MDTypography>
                          </MDBox>
                        )}
                        <MDBox mt={3} display="flex" justifyContent="start">
                          {(welcomeMessageText || welcomeMessageAudio) && (
                            <MDBox mr={2}>
                              <MDButton
                                variant="contained"
                                color="error"
                                size="small"
                                startIcon={<Icon>delete</Icon>}
                                onClick={() => deleteWelcomeMessage()}
                              >
                                Delete
                              </MDButton>
                            </MDBox>
                          )}
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              size="small"
                              startIcon={<Icon>volume_up</Icon>}
                              onClick={() => {
                                setWelcomeMessageFile(null);
                                setWelcomeMessageMsg(null);

                                setOpenWelcomeMessageDialog(true);
                              }}
                            >
                              {welcomeMessageText || welcomeMessageAudio ? "Update" : "Setup"}
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">Voicemail</MDTypography>
                        <Divider />
                      </MDBox>
                      <MDBox mt={2}>
                        {voicemailText || voicemailAudio ? (
                          <MDBox>
                            {voicemailText && (
                              <MDInput
                                fullWidth
                                InputProps={{
                                  readOnly: true,
                                  startAdornment: (
                                    <InputAdornment position="start">
                                      <Icon fontSize="small">voicemail</Icon>
                                    </InputAdornment>
                                  ),
                                }}
                                value={voicemailText}
                              />
                            )}
                            {voicemailAudio && (
                              <audio src={`${AppConfig.api_media_url}${voicemailAudio}`} controls>
                                Your browser does not support the audio element.
                              </audio>
                            )}
                          </MDBox>
                        ) : (
                          <MDBox>
                            <MDTypography variant="body2" fontSize={14}>
                              Set a voice mail to play to your customers when your call center is
                              closed or unavailable.
                            </MDTypography>
                          </MDBox>
                        )}
                        <MDBox mt={3} display="flex" justifyContent="start">
                          {(voicemailText || voicemailAudio) && (
                            <MDBox mr={2}>
                              <MDButton
                                variant="contained"
                                color="error"
                                size="small"
                                startIcon={<Icon>delete</Icon>}
                                onClick={() => deleteVoicemail()}
                              >
                                Delete
                              </MDButton>
                            </MDBox>
                          )}
                          <MDBox>
                            <MDButton
                              variant="contained"
                              color="dark"
                              size="small"
                              startIcon={<Icon>voicemail</Icon>}
                              onClick={() => {
                                setVoicemailFile(null);
                                setVoicemailMsg(null);

                                setOpenVoicemailDialog(true);
                              }}
                            >
                              {voicemailText || voicemailAudio ? "Update" : "Setup"}
                            </MDButton>
                          </MDBox>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6">IVR / Call Routing</MDTypography>
                    </MDBox>
                    <MDBox mt={-1}>
                      {(ivrMsg || ivrAudio) && (
                        <MDButton
                          variant="contained"
                          color="error"
                          size="small"
                          onClick={() => deleteIvr()}
                          iconOnly
                        >
                          <Icon>delete</Icon>
                        </MDButton>
                      )}
                      &nbsp;
                      <MDButton
                        variant="contained"
                        color="dark"
                        size="small"
                        onClick={() => {
                          setIvrFile(null);
                          setIvrText(null);
                          setOpenIvrDialog(true);
                        }}
                        iconOnly
                      >
                        <Icon>{ivrMsg || ivrAudio ? "edit" : "add"}</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <Divider />
                  <MDBox mt={2}>
                    {ivrAudio || ivrMsg ? (
                      <MDBox>
                        {ivrMsg && (
                          <MDInput
                            fullWidth
                            InputProps={{
                              readOnly: true,
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Icon fontSize="small">speaker</Icon>
                                </InputAdornment>
                              ),
                            }}
                            value={ivrMsg}
                          />
                        )}
                        {ivrAudio && (
                          <audio src={`${AppConfig.api_media_url}${ivrAudio}`} controls>
                            Your browser does not support the audio element.
                          </audio>
                        )}
                        <MDBox mt={5}>
                          <MDBox display="flex" justifyContent="space-between" mb={3}>
                            <MDBox>
                              <MDTypography variant="h6">Routing</MDTypography>
                            </MDBox>
                            <MDBox>
                              <MDButton
                                variant="outlined"
                                color="dark"
                                size="small"
                                onClick={() => {
                                  setIvrDMFT(null);
                                  setSelectedAgentGroup(null);
                                  setOpenIvrRouteDialog(true);
                                }}
                                iconOnly
                              >
                                <Icon>add</Icon>
                              </MDButton>
                            </MDBox>
                          </MDBox>
                          {ivr.routes.map((call_route) => (
                            <MDBox mb={2}>
                              <ListItem>
                                <ListItemText
                                  primary={
                                    <MDTypography
                                      variant="h6"
                                      fontSize={13}
                                    >{`DTMF: ${call_route.dmtf}`}</MDTypography>
                                  }
                                  secondary={call_route.group}
                                />
                                <MDButton
                                  color="error"
                                  variant="outlined"
                                  iconOnly
                                  size="small"
                                  onClick={() => deleteIvrRoute(call_route.reference)}
                                >
                                  <Icon>delete</Icon>
                                </MDButton>
                              </ListItem>
                            </MDBox>
                          ))}
                        </MDBox>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="body2" fontSize={14}>
                          Set up inbound smart call routing for your different teams.
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox p={2}>
                  <MDBox mb={2} display="flex" justifyContent="space-between">
                    <MDBox>
                      <MDTypography variant="h6">Operating Hours</MDTypography>
                    </MDBox>
                    <MDBox mt={-1}>
                      <MDButton
                        size="small"
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setOperatingDay([]);
                          setOperatingDirection([]);
                          setOperatingStart(null);
                          setOperatingEnd(null);
                          setOperatingEnabled(null);
                          setOperatingGroup([]);
                          setOpenOperatingHoursDialog(true);
                        }}
                      >
                        <Icon>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox>
                    <Divider />
                  </MDBox>
                  <MDBox mt={2}>
                    {orderedOperatingHours.length > 0 ? (
                      <MDBox>
                        <Grid container rowSpacing={2} columnSpacing={0}>
                          {orderedOperatingHours.map(([day, schedules]) => (
                            <Grid item xs={6} md={3} lg={3} key={day}>
                              <Card
                                sx={{
                                  height: "100%",
                                  marginTop: "0px",
                                  borderRadius: 0,
                                  border: "0.5px solid #e0e0e0",
                                }}
                              >
                                <MDBox p={2}>
                                  <MDTypography align="center" variant="h6">
                                    {day}
                                  </MDTypography>
                                  <MDBox mt={0}>
                                    {schedules.map((row) => (
                                      <Card
                                        key={row.reference}
                                        sx={{
                                          mt: 2.5,
                                          border: "1px solid #e0e0e0",
                                          boxShadow: "none",
                                        }}
                                      >
                                        <MDBox p={1.5}>
                                          <MDBox
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                          >
                                            <MDBox>
                                              <MDBox display="flex" alignItems="center">
                                                <Icon
                                                  sx={{
                                                    fontSize: 18,
                                                    mr: 0.75,
                                                    color:
                                                      row.direction === "INBOUND"
                                                        ? "#4caf50"
                                                        : "#2196f3",
                                                  }}
                                                >
                                                  {row.direction === "INBOUND"
                                                    ? "south_west"
                                                    : "north_east"}
                                                </Icon>

                                                <MDTypography variant="caption" fontWeight="medium">
                                                  {row.direction}
                                                </MDTypography>
                                              </MDBox>
                                            </MDBox>
                                            <IconButton
                                              size="small"
                                              onClick={() => deleteOperatingRecord(row.reference)}
                                            >
                                              <Icon color="error">delete</Icon>
                                            </IconButton>
                                          </MDBox>

                                          <MDBox mt={1} display="flex" alignItems="center" gap={1}>
                                            <Icon fontSize="small">groups</Icon>
                                            <MDTypography variant="button" fontWeight="regular">
                                              {row.agent_group || "All Agent Groups"}
                                            </MDTypography>
                                          </MDBox>

                                          <MDBox
                                            display="flex"
                                            alignItems="center"
                                            gap={1}
                                            mt={0.5}
                                          >
                                            <Icon fontSize="small">schedule</Icon>
                                            <MDTypography variant="caption" color="text">
                                              {`${row.open} - ${row.close}`}
                                            </MDTypography>
                                          </MDBox>

                                          <MDBox mt={1.5} display="flex" alignItems="center">
                                            <Chip
                                              size="small"
                                              label={`Calls ${
                                                row.enabled ? "Enabled" : "Disabled"
                                              }`}
                                              color={row.enabled ? "success" : "error"}
                                            />
                                            {/* <FormControlLabel
                                                    control={
                                                      <Checkbox checked={row.enabled} disabled />
                                                    }
                                                    label="Enabled"
                                                  /> */}
                                          </MDBox>
                                        </MDBox>
                                      </Card>
                                    ))}
                                  </MDBox>
                                </MDBox>
                              </Card>
                            </Grid>
                          ))}
                        </Grid>
                      </MDBox>
                    ) : (
                      <MDBox>
                        <MDTypography variant="body2" fontSize={14}>
                          Set operating days and hours your business or call center will be
                          available to make and receive calls. Create team shifts for inbound and
                          outbound calls.
                        </MDTypography>
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%" }}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                  <MDBox>
                    <MDTypography variant="h6">Whatsapp Connection</MDTypography>
                    <MDTypography variant="body2" fontSize={14}>
                      Enable your team seamlessly continue call conversations and follow ups over
                      Whatsapp messaging.
                    </MDTypography>
                  </MDBox>
                  <MDButton
                    variant="contained"
                    color="dark"
                    size="small"
                    onClick={() => {
                      setSelectedWacc("");
                      setOpenAttachWaccDialog(true);
                    }}
                    iconOnly
                  >
                    <Icon>add</Icon>
                  </MDButton>
                </MDBox>
                <MDBox>
                  {callCenterWaccs.length === 0 ? (
                    <MDBox p={2} align="left">
                      <MDTypography variant="body2" color="text" sx={{ mt: 2 }}>
                        No whatsapp numbers are attached to this call center yet.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox mt={2}>
                      <DataTable
                        table={{
                          columns: waccTableColumns,
                          rows: buildWaccRows(callCenterWaccs),
                        }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                        canSearch={false}
                      />
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ height: "100%" }}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" p={2}>
                  <MDBox>
                    <MDTypography variant="h6">Campaigns</MDTypography>
                    <MDTypography variant="body2" fontSize={14}>
                      Enable your team capture sales and/or customer information during or after a
                      call. Requires an active Field OS campaign.
                    </MDTypography>
                  </MDBox>
                  <MDButton
                    variant="contained"
                    color="dark"
                    size="small"
                    onClick={() => {
                      setSelectedCampaign("");
                      setOpenAttachCampaignDialog(true);
                    }}
                    iconOnly
                  >
                    <Icon>add</Icon>
                  </MDButton>
                </MDBox>
                <MDBox>
                  {callCenterCampaigns.length === 0 ? (
                    <MDBox p={2} align="left">
                      <MDTypography variant="body2" color="text" sx={{ mt: 2 }}>
                        No campaigns are attached to this call center yet.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox mt={2}>
                      <DataTable
                        table={{
                          columns: campaignTableColumns,
                          rows: buildCampaignRows(callCenterCampaigns),
                        }}
                        isSorted
                        entriesPerPage={false}
                        showTotalEntries
                        buttons
                        noEndBorder
                        canSearch={false}
                      />
                    </MDBox>
                  )}
                </MDBox>
              </Card>
            </MDBox>

            <MDBox mt={5}>
              <Card sx={{ p: 2, height: "100%" }}>
                <MDBox display="flex" justifyContent="space-between">
                  <MDBox>
                    <MDTypography variant="h6">Quality Control</MDTypography>
                  </MDBox>
                  <MDBox display="flex" gap={1}>
                    <MDButton
                      variant="outlined"
                      color="dark"
                      onClick={() => {
                        navigate(`/voice/call-centers/quality-control/${ref}`);
                      }}
                      startIcon={
                        <Icon sx={{ cursor: "pointer" }} fontSize="small">
                          list
                        </Icon>
                      }
                      size="small"
                    >
                      Reviews
                    </MDButton>
                    <MDButton
                      variant="outlined"
                      color="dark"
                      onClick={() => {
                        navigate(`/voice/call-centers/quality-control/reports/${ref}`);
                      }}
                      startIcon={
                        <Icon sx={{ cursor: "pointer" }} fontSize="small">
                          trending_up
                        </Icon>
                      }
                      size="small"
                    >
                      Insights
                    </MDButton>
                  </MDBox>
                </MDBox>
                <Grid container spacing={3} sx={{ mt: 2 }}>
                  <Grid item xs={12} md={4}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={2}
                      >
                        <MDTypography variant="h6" fontWeight="regular">
                          Evaluation Metrics
                        </MDTypography>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          onClick={() => setOpenMetricDialog(true)}
                          iconOnly
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                      <Divider />
                      {qaMetrics.length > 0 ? (
                        <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                          {qaMetrics.map((metric) => (
                            <Chip
                              key={metric.reference}
                              label={metric.title}
                              color="info"
                              variant="contained"
                              size="large"
                              onDelete={() => removeQaMetric(metric.reference)}
                            />
                          ))}
                        </MDBox>
                      ) : (
                        <MDTypography
                          variant="caption"
                          color="text"
                          sx={{ display: "block", mt: 1 }}
                        >
                          No explicit evaluation rubrics attached to this call center setup.
                        </MDTypography>
                      )}
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <Divider
                      orientation="vertical"
                      sx={{ display: { xs: "none", md: "block", lg: "block" } }}
                    />
                  </Grid>
                  <Grid item xs={12} md={7}>
                    <MDBox>
                      <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        mb={1}
                      >
                        <MDTypography variant="h6" fontWeight="regular">
                          Evaluation Templates (Score cards)
                        </MDTypography>
                        <MDButton
                          variant="contained"
                          color="dark"
                          size="small"
                          onClick={() => setOpenTemplateDialog(true)}
                          iconOnly
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                      <Divider />
                      {qaTemplates.length > 0 ? (
                        <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                          {qaTemplates.map((template) => (
                            <ListItem key={template.reference}>
                              <ListItemText
                                primary={
                                  <MDBox
                                    display="flex"
                                    justifyContent="space-between"
                                    alignItems="center"
                                    my={2}
                                  >
                                    <MDTypography variant="body2">{template.title}</MDTypography>
                                    <MDBox display="flex" flexWrap="wrap" gap={1}>
                                      <MDButton
                                        variant="outlined"
                                        color="dark"
                                        size="small"
                                        onClick={() => {
                                          setSelectedTemplate(template.reference);
                                          setSelectedMetric(null);
                                          setOpenAttachTemplateMetric(true);
                                        }}
                                        iconOnly
                                        title="Add Metric"
                                      >
                                        <Icon>add</Icon>
                                      </MDButton>
                                      <MDButton
                                        variant="outlined"
                                        color="error"
                                        size="small"
                                        onClick={() => removeQaTemplate(template.reference)}
                                        iconOnly
                                        title="Delete Template"
                                      >
                                        <Icon>delete</Icon>
                                      </MDButton>
                                    </MDBox>
                                  </MDBox>
                                }
                                secondary={
                                  <>
                                    {template.metrics.length > 0 ? (
                                      <MDBox display="flex" flexWrap="wrap" gap={1} mt={1} mb={2}>
                                        {template.metrics.map((metric) => (
                                          <Chip
                                            key={metric.reference}
                                            label={metric.title}
                                            color="info"
                                            variant="contained"
                                            size="small"
                                            onDelete={() =>
                                              removeQaTemplateMetric(metric.reference)
                                            }
                                          />
                                        ))}
                                      </MDBox>
                                    ) : (
                                      <MDTypography
                                        variant="caption"
                                        color="text"
                                        sx={{ display: "block", my: 1 }}
                                      >
                                        No evaluation metrics assigned to this template.
                                      </MDTypography>
                                    )}
                                  </>
                                }
                              />
                            </ListItem>
                          ))}
                        </MDBox>
                      ) : (
                        <MDTypography
                          variant="caption"
                          color="text"
                          sx={{ display: "block", mt: 1 }}
                        >
                          No scoring templates assigned to this call center.
                        </MDTypography>
                      )}
                    </MDBox>
                  </Grid>
                </Grid>
              </Card>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default CallCenterPage;
